import {createPaginationHook} from '@/utils/createPaginationHook';
import RolApiService from '@/modules/admin/services/RolApiService';

export const useSearchRol = createPaginationHook('user-roles', RolApiService.getRoles);
